import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getProcessLineItems = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/`);
        return await response.data;
    } catch (error) {
        console.log("getProcessLineItems - error", error)
        return handleApiError(error)
    }
}

export const updateProcessLineItems = async (processLineItemId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/update/${processLineItemId}`, data)
        return await response.data
    } catch (error) {
        console.log("updateProcessLineItems - error", error)
        return handleApiError(error)
    }
}


export const getProcessLineItemsByProcessLineId = async (processLineId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/by-process-line-id/${processLineId}`, data);
        return await response.data;
    } catch (error) {
        console.log("getProcessLineItemsByProcessLineId - error", error)
        return handleApiError(error)
    }
}

export const getPendingProcessLineItems = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/pending-items`);
        return await response.data;
    } catch (error) {
        console.log("getPendingProcessLineItems - error", error)
        return handleApiError(error)
    }
}

export const deleteProcessLineItem = async (processLineItemId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/delete/${processLineItemId}`, data);
        return await response.data;
    } catch (error) {
        console.log("deleteProcessLineItem - error", error)
        return handleApiError(error)
    }
}

export const assignNextProcessLineItem= async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/assign-next/`, data)
        return await response.data
    } catch (error) {
        console.log("assignNextProcessLineItem - error", error)
        return handleApiError(error)
    }
}

export const manualAssignProcessLineItem= async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/process-line-items/manual-assign/`, data)
        return await response.data
    } catch (error) {
        console.log("manualAssignProcessLineItem - error", error)
        return handleApiError(error)
    }
}


